import React from 'react'
import "../FinalStep.css"
import finalImg from '../../../assets/images/payment/flight-payment-success.svg'


const FinalStep = () => {
  return (
    <div className='confirmation-step'>
        <div className='confirmation-title'>Payment successful!</div>
        <div className='confirmation-para'>
            Your ticket is now being issued and will be sent to your email shortly . .
        </div>
        <img src={finalImg} className='mt-4' />
    </div>
  )
}

export default FinalStep
